// export function store(applicationId, data)
// {
//     return axios.post(route('api.manage.applications.extension-requests.store', {applicationId}) + '', data)
//         .then(response => response.data);
// }

export function preview(data)
{
    return axios.post(route('api.manage.companies.extension-requests.preview'), data)
        .then(response => response.data);
}

export function storeBulk(data, filters)
{
    filters = filters || {};

    return axios.post(
        route('api.manage.companies.extension-requests.store') + '?include=timelineEvent',
        data,
        {params: {...filters}}
    ).then(response => response.data);
}

export function indexForApplication(applicationId, accepted)
{
    const query = accepted ? '?filter[accepted]=1' : ''

    return axios.get(route('api.manage.applications.extension-requests.index-for-application', {applicationId}) + query)
        .then(response => response.data);
}
